import API from "../../../app/api";
export const getObsessedRightNow = async () => {
  try {
    const res = await API.get("/banners/section/OBSESSED_RIGHT_NOW");
    if (!res.data?.success) {
      throw new Error(
        res.data?.message || "Failed to fetch Obsessed Right Now"
      );
    }
    return res.data?.data?.banners || [];
  } catch (error) {
    console.error("getObsessedRightNow error:", error);
    return [];
  }
};